"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var utils_1 = require("./utils");
var axiosInstance = axios_1.default.create({
    baseURL: '/good/api/v3',
    headers: {
        post: {
            'Content-Type': 'application/json',
        },
    },
});
var Endpoint = /** @class */ (function () {
    function Endpoint() {
    }
    Endpoint.prototype.search = function (data, options) {
        return axiosInstance
            .request(__assign({ method: 'POST', url: "struct/" + this.name + "/search" }, options, { data: data }))
            .then(utils_1.extractResponseData);
    };
    /**
     * FromIndex - search in indexed db. (options and all same like in the Search)
     */
    Endpoint.prototype.fromIndex = function (data, options) {
        return axiosInstance
            .request(__assign({ method: 'POST', url: "struct/" + this.name + "/fromIndex" }, options, { data: data }))
            .then(utils_1.extractResponseData);
    };
    /**
     * Save (create/update) data.
     */
    Endpoint.prototype.save = function (data, options) {
        return axiosInstance
            .request(__assign({ method: 'POST', url: "struct/" + this.name + "/" }, options, { data: data }))
            .then(utils_1.extractResponseData);
    };
    /**
     * @param scenarioNames Scenario names (separated by comma).
     * @param data Data to save.
     * @param fields Fields that will be returned (separated by comma).
     */
    Endpoint.prototype.saveSync = function (scenarioNames, data, fields) {
        if (fields === void 0) { fields = ''; }
        var params = {
            sync: true,
            pilotSysNames: scenarioNames,
            fields: fields,
        };
        return axiosInstance
            .request({
            method: 'POST',
            url: "struct/" + this.name + "/",
            params: params,
            data: data,
        })
            .then(utils_1.extractResponseData);
    };
    /**
     *
     * @return {Promise}
     */
    Endpoint.prototype.list = function () {
        return axiosInstance
            .request({
            method: 'GET',
            url: "struct/" + this.name + "/list",
        })
            .then(utils_1.extractResponseData);
    };
    /**
     * GET request for API V5
     *
     * @return {Promise}
     */
    Endpoint.prototype.getData = function (name, params, options) {
        return axiosInstance
            .request(__assign({ method: 'GET', url: "data/" + this.name + "/" + name, baseURL: '/good/api/v5', params: params }, options))
            .then(utils_1.extractResponseData);
    };
    /**
     * POST request for API V5
     *
     * @return {Promise}
     */
    Endpoint.prototype.sendData = function (name, data, options) {
        return axiosInstance
            .request(__assign({ method: 'POST', url: "data/" + this.name + "/" + name, baseURL: '/good/api/v5', data: data }, options))
            .then(utils_1.extractResponseData);
    };
    /**
     *
     * @return {Promise}
     */
    Endpoint.prototype.metainfo = function () {
        return axiosInstance
            .request({
            method: 'GET',
            url: "struct/" + this.name + "/metainfo",
        })
            .then(utils_1.extractResponseData);
    };
    return Endpoint;
}());
exports.Endpoint = Endpoint;
var Structure = /** @class */ (function (_super) {
    __extends(Structure, _super);
    function Structure(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        return _this;
    }
    return Structure;
}(Endpoint));
exports.Structure = Structure;
exports.api = {
    createCancelToken: axios_1.default.CancelToken.source,
    isCancel: axios_1.default.isCancel,
    /**
     * @see https://github.com/axios/axios#config-defaults
     * @see https://github.com/axios/axios#request-config
     * @type {AxiosRequestConfig}
     */
    defaults: axiosInstance.defaults,
    /**
     * Create structure bound endpoint.
     */
    structure: function (name) {
        return new Structure(name);
    },
    /**
     * Upload a file.
     */
    fileUpload: function (file, options) {
        var data = new FormData();
        data.append('file', file);
        return axiosInstance
            .request(__assign({ method: 'POST', url: 'file/upload', params: {
                source: 'others',
            } }, options, { data: data }))
            .then(utils_1.extractResponseData);
    },
    /**
     * Apply OR operator from api.
     */
    decorateWithOrOperator: function (filters) {
        return [
            {
                value: '',
                field: '',
                exp: '',
                operator: 'OR',
                filters: filters,
            },
        ];
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/directual/lib/api.js
// module id = 783
// module chunks = 0